<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :types="fieldTypes" :board="this.board" :is-print="isPrint" class="mt-8"/>

    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 소견서 정보</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>대상 부서명</div>
          <p v-if="isPrint" class="print-input">{{ form.대상부서명 }}</p>
          <ml-input v-else v-model="form.대상부서명" class="w-full" />
        </div>
        <div class="writeGridLineItem">
          <div>대상자 성명</div>
          <p v-if="isPrint" class="print-textarea">{{ form.대상자성명 }}</p>
          <ml-textarea v-else v-model="form.대상자성명" class="w-full" />
        </div>
        <div class="writeGridLineItem">
          <div>특이사항</div>
          <p v-if="isPrint" class="print-textarea">{{ form.특이사항 }}</p>
          <ml-textarea v-else v-model="form.특이사항" class="w-full" />
        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";

export default {
  components: {
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    fieldTypes() {
      return ["com_name", "rank", "writer_name", "date"];
    },
  },
  data() {
    return {
      allCheck: false,
      form: {
        stdInfo: {},
        fileList: [],
        대상부서명: "",
        대상자성명: "",
        특이사항: "",
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },

};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    th {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;

      background: #f9f9f9;
      border: solid #cdcdcd 1px;
      padding: 6px;
    }
  }
  tbody {
    tr {
      td {
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        padding: 5px;
        border: solid #cdcdcd 1px;

        div {
          align-items: center;
        }
      }
    }
  }
}
</style>
